import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

export interface DefinitionListProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
	title?:    ReactNode
	children:  ReactNode
}

function DefinitionList({ title, children, className, ...props }: DefinitionListProps) {
	return (
		<section className={cn('flex flex-col gap-2', className)} {...props}>
			{title && <h2 className="text-base font-[500] text-(--color-foreground)">{title}</h2>}
			<div className="rounded-(--radius-md) border border-(--color-border) bg-(--color-card) p-4">
				<dl className="grid grid-cols-[8rem_1fr] gap-x-4 gap-y-2 text-sm">
					{children}
				</dl>
			</div>
		</section>
	)
}

export interface DefinitionRowProps {
	label:        string
	value?:       ReactNode
	placeholder?: ReactNode
}

function DefinitionRow({ label, value, placeholder }: DefinitionRowProps) {
	const hasValue = value !== undefined && value !== null && value !== ''
	return (
		<>
			<dt className="text-(--color-muted-foreground)">{label}:</dt>
			<dd className={hasValue ? 'text-(--color-foreground)' : 'text-(--color-muted-foreground)'}>
				{hasValue ? value : (placeholder ?? '—')}
			</dd>
		</>
	)
}

export { DefinitionList, DefinitionRow }
